export default __webpack_public_path__ + "static/media/pen.5338521f.svg";